module.exports = __webpack_public_path__ + "static/carSilver2-e9fd29ae6699abda08c5145cb7d9c7c5.png";